import { render, staticRenderFns } from "./choice_collect.vue?vue&type=template&id=41c88df1&"
import script from "./choice_collect.vue?vue&type=script&lang=js&"
export * from "./choice_collect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports